import { useMemo } from "react";
import type { ProtoSquadPlayer } from "@catbento/shared";
import { readSnapshot } from "../data/snapshot.js";
import type { CompetitionId } from "../data/league.js";
import { getSquad, getSquadTeams } from "../data/squad.js";

// Phase-04 data seam for the Squad module (the one renderer Phase 02 didn't cover), by
// league id (ids-2). At the Part-2 cutover these fetch a team-roster endpoint and adapt to
// the same ProtoSquadPlayer shape.

const NO_TEAMS: string[] = [];
const NO_PLAYERS: ProtoSquadPlayer[] = [];

/** Team names for a league (its newest league-table season, sorted). */
export function useSquadTeams(competitionId: CompetitionId | null): string[] {
  return useMemo(
    () => (competitionId === null ? NO_TEAMS : getSquadTeams(readSnapshot(), competitionId)),
    [competitionId],
  );
}

/** A team's roster in a league, sorted by name. Empty if none captured. */
export function useSquad(competitionId: CompetitionId | null, team: string): ProtoSquadPlayer[] {
  return useMemo(
    () => (competitionId === null ? NO_PLAYERS : getSquad(readSnapshot(), competitionId, team)),
    [competitionId, team],
  );
}
